import { noop } from 'es-toolkit';
import waitReject from './waitReject';
export default function rejectAfter(promise, duration, reason = 'TIMED_OUT') {
    if (!promise) {
        return undefined;
    }
    if (!duration) {
        return promise;
    }
    const timeoutPromise = waitReject(duration, reason);
    promise.finally(() => timeoutPromise.resolve()).catch(noop);
    return Promise.race([promise, timeoutPromise]);
}
